import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateRechnungslaufMutation, useDeleteRechnungslaufMutation, useGetRechnungslaufMutation } from '../../api/FakturaAPI';
import { IRechnungslauf } from '../../types/Types';
import LandingpageHeader from '../header/LandingpageHeader';

const emptyDto: IRechnungslauf = {
  uid: '',
  name: '',
  bisdatum: new Date(),
  leistungsdatum: '',
  rechnungsDatum: undefined,
}

export default function RechnungslaufDetail() {
  const { t } = useTranslation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IRechnungslauf>(emptyDto);

  const [getRechnungslaufAPI] = useGetRechnungslaufMutation();

  const [deleteRechnungslaufAPI] = useDeleteRechnungslaufMutation();
  const [createOrUpdateRechnungslaufAPI] = useCreateOrUpdateRechnungslaufMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const init = () => {

    if (location.state.view === 'detail') {
      getRechnungslaufAPI(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten(e);
          setLoaded(true);
        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyDto)
      setLoaded(true);
    }
  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteRechnungslaufAPI(daten!.uid).unwrap()
        .then(() => navigate('/faktura/rechnungslaufListe/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail' || location.state.view === 'create') {

      createOrUpdateRechnungslaufAPI(daten)
        .then(resp => navigate('/faktura/rechnungslaufListe'))
        .catch((ee) => console.log(ee))

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("/faktura/rechnungslaufListe", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Rechnungslauf Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form className='form-group' onSubmit={handleSubmit} >
            {(isLoaded && daten !== undefined &&
              <>
                <div>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.name}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" onClick={handleDelete} className='btn btn-danger'><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div>
                  <label>Name</label>
                  <input type="text" className="form-control  " name="name" value={daten?.name} onChange={changeit} />
                </div>

                <div>
                  <label>Rechnungsdatum</label>
                  <input type="date" className="form-control" name="rechnungsDatum" value={""+daten?.rechnungsDatum } onChange={changeit} />
                </div>

                <div>
                  <label>Bis</label>
                  <input type="date" className="form-control" name="bisdatum" value={"" + daten?.bisdatum} onChange={changeit} />
                </div>

                <div>
                  <label>Leistungsdatum</label>
                  <select name="leistungsdatum" className="form-control" onChange={changeitselect} value={"" + daten.leistungsdatum}>
                    {/*<option value={""}>-- Bitte auswählen --</option>*/}
                    <option value="TERMIN" selected={daten.leistungsdatum === "termin" ? true : false}>Termin</option>
                    <option value="ERLEDIGT" selected={daten.leistungsdatum === "erledigt" ? true : false}>Erledigt</option>
                  </select>
                </div>

                <div>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className="btn btn-primary" /></div>
                  <div></div>
                </div>

              </>)}
          </form>


        </div>
      </div >
    </>
  );
}